import CustomBarWidth from '@common-components/graphs/custom-bar-width-graph/CustomBarWidth'
import React from 'react'
import {  useParams, useSearchParams } from 'react-router-dom';

export default function QualityGraph() {
    const params = useParams()
    const [searchParams] = useSearchParams();
  const batchId = searchParams.get("batchID"); 
  return (
    <div className='mt-10'>
    <CustomBarWidth type= "full" supplierID = {params.id} batchId = {batchId}/>
    </div>
  )
}
